import { get } from 'lodash-es';

import * as FileTypes from './fileTypes.const';

// These are pure functions, so define them here instead of on the class
const isReady = (file) => get(file, 'isReady');

const isError = (file) => get(file, 'error');

const isParsing = (file) => !isReady(file) && !isError(file);

class SelectedFileSummaryCtrl {
  static bindings = {
    file: '<',
    acceptableExtensions: '<',
    deleteFile: '&',
    allowDelete: '<',
    showDownloadUrl: '<',
    showFileSize: '<'
  };

  acceptableExtensions: string[];

  deleteFile;

  file;

  isExcelFile = FileTypes.isExcelFile;

  isCsvFile = FileTypes.isCsvFile;

  isPdfFile = FileTypes.isPdfFile;

  isDocxFile = FileTypes.isDocxFile;

  // Initialize this until $onChanges gets a list of valid extensions
  isValidFileType = (file) => true;

  isParsing = isParsing;

  isReady = isReady;

  isError = isError;

  $onChanges(changes) {
    if (
      changes.acceptableExtensions &&
      Array.isArray(changes.acceptableExtensions.currentValue)
    ) {
      this.isValidFileType = FileTypes.checkFileExt(
        ...changes.acceptableExtensions.currentValue
      );
    }
  }

  onClickDeleteFile(e) {
    this.deleteFile({ file: this.file });
    e.stopPropagation();
  }
}

export const SelectedFileSummaryComponent = {
  template: require('./selectedFileSummary.component.html'),
  controller: SelectedFileSummaryCtrl,
  bindings: SelectedFileSummaryCtrl.bindings
};
